import { forwardRef, Fragment, useEffect, useImperativeHandle, useState } from "react";

export const DeliveryInstructionReuired = forwardRef(({}, ref) => {
  const [showToast, setShowToast] = useState(false);

  useImperativeHandle(ref, () => ({
    showAlert,
  }));
  const showAlert = () => {
    setShowToast(true);
  };
  return (
    <Fragment>
      {showToast == true && (
        <div
          className="toast error-toast error-toast-orangeDark show animate__animated animate__bounceIn"
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
        >
          <div className="toast-body error-toast-body">
            <div className="toast-body-message">
              <div className="lft-toast-icon toast-orangeDark-icon">
                <div className="toast-icon-inner toast-orange-dark">
                  <span className="wes-order-number" />
                </div>
              </div>
              <div className="lft-toast-msg lft-toast-msgOrangeDark">
                <h6>Please add delivery Instructions </h6>
                <p>Delivery instructions are required when signature required is selected as NO</p>
              </div>
            </div>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={() => {
                setShowToast(false);
              }}
            />
          </div>
        </div>
      )}
    </Fragment>
  );
});
